import {
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  useMediaQuery
} from '@mui/material'
import { useTheme } from '@mui/styles'
import React, { useEffect, useState } from 'react'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import AppButton from '../../../commonComponents/AppButton'
import CautionModal from './CautionModal'
import StepsView from './StepsView'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import PhoneInput from '../../../commonComponents/PhoneInput'
import ProfileCompletion from './ProfileCompletion'
import { isEmpty, showToast } from '../../../utils/AppHelper'

export default function RecruiterEditProfile () {
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.down('sm')) // Detect small screens

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()

  const [openCautionModal, setOpenCautionModal] = useState({ open: false })

  const [stages, setSteps] = useState([])
  const [currentStage, setCurrentStage] = useState({})
  const [currentQuestion, setCurrentQuestion] = useState({
    index: 0,
    item: null
  })
  const [loading, setLoading] = useState(true)
  const [loadingBtn, setLoadingBtn] = useState(false)

  const [profileCompletion, setProfileCompletion] = useState(false)

  useEffect(() => {
    getRecruiterProfile()
  }, [])

  function findUnAnswered (response) {
    const state = location.state

    for (let i = 0; i < response.length; i++) {
      const step = response[i]
      for (let j = 0; j < step.questions.length; j++) {
        const question = step.questions[j]
        if (!isEmpty(state)) {
          if (question.type === state) {
            return { step, question: { index: j, item: question } }
          }
        } else if (isEmpty(question.answer)) {
          return { step, question: { index: j, item: question } }
        }
      }
    }
    return null
  }

  function getRecruiterProfile () {
    serverData.getRecruiterProfile(
      {},
      result => {
        if (result.status) {
          var { response } = result
          setSteps(response)
          var data = findUnAnswered(response)
          if (data) {
            setCurrentStage(data.step)
            setCurrentQuestion(data.question)
          } else {
            setCurrentStage(response[0])
            setCurrentQuestion({ index: 0, item: response[0].questions[0] })
          }
        }
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  function changeStep () {
    var index = stages.findIndex(e => e.stepId === currentStage.stepId)
    if (index < stages.length - 1) {
      setCurrentStage(stages[index + 1])
      setCurrentQuestion({ index: 0, item: stages[index + 1].questions[0] })
    } else {
      setProfileCompletion(true)
    }
  }

  function changeQuestion () {
    var index = currentStage.questions.findIndex(
      e => e.questionId === currentQuestion.item.questionId
    )
    if (index < currentStage.questions.length - 1) {
      setCurrentQuestion({
        index: index + 1,
        item: currentStage.questions[index + 1]
      })
    } else {
      changeStep()
    }
  }

  function handleSubmit () {
    setLoadingBtn(true)
    var { questionId, answer, type, primaryPhone } = currentQuestion.item
    var body = {
      questionId: questionId,
      answer: Array.isArray(answer) ? answer.join(',') : answer
    }
    if (type === 'phone') {
      body.primaryPhone = primaryPhone
    }

    var isFinalStage =
      stages.findIndex(e => e.stepId === currentStage.stepId) ===
      stages.length - 1
    var isLastQuestion =
      currentStage.questions.findIndex(
        e => e.questionId === currentQuestion.item.questionId
      ) ===
      currentStage.questions.length - 1

    if (isFinalStage && isLastQuestion) {
      body.isProfileCompleted = true
    }

    serverData.updateRecruiterProfile(
      body,
      result => {
        if (result.status) {
          changeQuestion()
        } else {
          showToast(result.message)
        }
        setLoadingBtn(false)
      },
      error => {
        setLoadingBtn(false)

        if (error.status === 401) {
          dispatch(logoutUser(navigate)) // eslint-disable-next-line
        }
      }
    )
  }

  return loading ? (
    <Grid
      container
      spacing={2}
      direction={'column'}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        width: '100%'
      }}
    >
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  ) : profileCompletion ? (
    <ProfileCompletion matches={matches} />
  ) : (
    <Grid container>
      <Grid
        item
        xs={matches ? 12 : 8}
        style={{
          backgroundColor: theme.palette.background.paper,
          borderRadius: 16,
          padding: 24,
          justifyContent: 'space-between',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Grid container style={{ justifyContent: 'space-between' }}>
          <Grid item xs={matches ? 12 : 3}>
            <Grid item xs={12}>
              <TextRegular>
                {currentQuestion?.index + 1} of{' '}
                {currentStage?.questions?.length} questions in this step
              </TextRegular>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                width: '100%',
                height: '8px',
                backgroundColor: theme.palette.border.main,
                margin: '5px 0px'
              }}
            >
              <Box
                style={{
                  width: `${
                    ((currentQuestion?.index + 1) * 100) /
                    currentStage?.questions?.length
                  }%`,
                  height: '100%',
                  backgroundColor: theme.palette.primary.main
                }}
              />
            </Grid>
          </Grid>
          <Grid item>
            {currentQuestion.index !== 0 && (
              <AppButton
                name={'< Back'}
                variant='text'
                onClick={() => {
                  setCurrentQuestion({
                    index: currentQuestion.index - 1,
                    item: currentStage.questions[currentQuestion.index - 1]
                  })
                }}
              />
            )}
          </Grid>
        </Grid>

        <Grid
          container
          style={{
            marginTop: 32,
            flex: 1,

            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Grid item>
            <TextBold style={{ fontSize: '16px' }}>
              {currentQuestion?.item?.question}
            </TextBold>
          </Grid>
          <Grid item style={{ marginTop: 16, flex: 1 }}>
            {currentQuestion.item?.type === 'radio' && (
              <RadioGroup
                row
                name='row-radio-buttons-group'
                onChange={e => {
                  var data = { ...currentQuestion }
                  data.item.answer = e.target.value
                  setCurrentQuestion(data)
                }}
                value={currentQuestion?.item.answer}
              >
                {currentQuestion?.item?.options?.map((opt, index) => (
                  <Grid xs={12}>
                    <FormControlLabel
                      value={opt.optionId}
                      control={<Radio />}
                      label={opt.answer}
                    />
                  </Grid>
                ))}
              </RadioGroup>
            )}

            {(currentQuestion.item?.type === 'checkbox' ||
              currentQuestion.item?.type === 'functionalroles' ||
              currentQuestion.item?.type === 'industrialroles') && (
              <Grid container xs={12}>
                {currentQuestion?.item?.options?.map((opt, oIndex) => {
                  var isChecked = currentQuestion.item.answer?.includes(
                    opt.optionId
                  )
                  return (
                    <Grid
                      item
                      xs={
                        currentQuestion.item?.type === 'checkbox'
                          ? 12
                          : matches
                          ? 12
                          : 4
                      }
                    >
                      <FormControlLabel
                        key={oIndex}
                        control={
                          <Checkbox
                            value={opt.optionId}
                            checked={isChecked}
                            onChange={e => {
                              var { value } = e.target
                              var data = { ...currentQuestion }
                              var arr = isEmpty(data.item.answer)
                                ? []
                                : Array.isArray(data.item.answer)
                                ? data.item.answer
                                : data.item.answer.split(',')
                              if (isChecked) {
                                var i = arr.findIndex(e => e == value)
                                arr.splice(i, 1)
                              } else {
                                if (
                                  currentQuestion.item?.type ===
                                    'functionalroles' ||
                                  currentQuestion.item?.type ===
                                    'industrialroles'
                                ) {
                                  if (arr.length < 5) {
                                    arr.push(value)
                                  } else {
                                    showToast('You can only select 5 fields')
                                  }
                                } else {
                                  arr.push(value)
                                }
                              }
                              data.item.answer = arr.length > 0 ? arr : ''
                              setCurrentQuestion(data)
                            }}
                            name={opt.answer}
                          />
                        }
                        label={opt.answer}
                      />
                    </Grid>
                  )
                })}
              </Grid>
            )}
            {currentQuestion.item?.type === 'phone' && (
              <Grid xs={6} container>
                <TextRegular
                  style={{
                    marginBottom: 8,
                    color: theme.palette.text.secondary
                  }}
                >
                  Primary contact number *
                </TextRegular>
                <PhoneInput
                  id='Primary phone number'
                  variant='outlined'
                  fullWidth
                  name='phone'
                  value={currentQuestion.item.primaryPhone}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    var data = { ...currentQuestion }
                    data.item.primaryPhone = input
                    setCurrentQuestion(data)
                  }}
                  error={
                    isEmpty(currentQuestion.item.primaryPhone) ||
                    currentQuestion.item.primaryPhone.length !== 10
                  }
                  helperText={
                    isEmpty(currentQuestion.item.primaryPhone) ||
                    currentQuestion.item.primaryPhone.length !== 10
                      ? 'Please enter a valid phone number'
                      : ''
                  }
                />
                <TextRegular
                  style={{
                    marginBottom: 8,
                    color: theme.palette.text.secondary,
                    marginTop: 16
                  }}
                >
                  Secondary contact number
                </TextRegular>
                <PhoneInput
                  id='Secondary phone number'
                  variant='outlined'
                  fullWidth
                  name='phone'
                  value={currentQuestion.item.answer}
                  onChange={e => {
                    const input = e.target.value.replace(/\D/g, '')
                    var data = { ...currentQuestion }
                    data.item.answer = input
                    setCurrentQuestion(data)
                  }}
                  error={
                    isEmpty(currentQuestion.item.answer)
                      ? false
                      : currentQuestion.item.answer.length !== 10
                  }
                  helperText={
                    isEmpty(currentQuestion.item.answer)
                      ? ''
                      : currentQuestion.item.answer.length !== 10
                      ? 'Please enter a valid phone number'
                      : ''
                  }
                />
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 24
          }}
        >
          <Grid item>
            <AppButton
              name={'Next'}
              loading={loadingBtn}
              disabled={
                currentQuestion.item.type === 'phone'
                  ? isEmpty(currentQuestion.item.primaryPhone) ||
                    currentQuestion.item.primaryPhone.length !== 10 ||
                    (!isEmpty(currentQuestion.item.answer) &&
                      currentQuestion.item.answer.length !== 10)
                  : isEmpty(currentQuestion.item.answer)
              }
              style={{
                padding: '12px 26px'
              }}
              onClick={handleSubmit}
            />
          </Grid>
          <Grid item>
            <AppButton
              variant='outlined'
              disabled={loadingBtn}
              name={'Skip this question'}
              style={{
                padding: '12px 26px'
              }}
              onClick={changeQuestion}
            />
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 24
          }}
        >
          <Grid item xs={4} />
          <Grid
            item
            xs={matches ? 12 : 4}
            style={{
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <AppButton
              name={'Skip this step for now'}
              fullWidth={false}
              disabled={loadingBtn}
              style={{
                padding: '12px 26px'
              }}
              variant='text'
              onClick={() => {
                setOpenCautionModal({
                  open: true,
                  onClose: () => {
                    setOpenCautionModal({ open: false })
                  },
                  changeStep: changeStep
                })
              }}
            />
          </Grid>
          <Grid
            item
            xs={matches ? 12 : 4}
            style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            {stages.findIndex(e => e.stepId === currentStage.stepId) !== 0 && (
              <AppButton
                name={'< Prev step'}
                variant='text'
                fullWidth={false}
                onClick={() => {
                  var prevStep =
                    stages[
                      stages.findIndex(e => e.stepId === currentStage.stepId) -
                        1
                    ]
                  setCurrentStage(prevStep)
                  setCurrentQuestion({
                    index: 0,
                    item: prevStep.questions[0]
                  })
                }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={matches ? 12 : 4}
        style={{ paddingLeft: matches ? 0 : 24, display: 'flex' }}
      >
        <StepsView
          stages={stages}
          currentStage={currentStage}
          matches={matches}
        />
      </Grid>

      {openCautionModal?.open && (
        <CautionModal data={openCautionModal} matches={matches} />
      )}
    </Grid>
  )
}
